// extracted by mini-css-extract-plugin
module.exports = {"title":"Offers_title__GIVHS","description":"Offers_description__MElfM"};